/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { CertiDapp } from "./CertiDapp";

export class CertiDappFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<CertiDapp> {
    return super.deploy(overrides || {}) as Promise<CertiDapp>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): CertiDapp {
    return super.attach(address) as CertiDapp;
  }
  connect(signer: Signer): CertiDappFactory {
    return super.connect(signer) as CertiDappFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CertiDapp {
    return new Contract(address, _abi, signerOrProvider) as CertiDapp;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_auth",
        type: "address",
      },
    ],
    name: "Authorities",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "hashedinput",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "doner",
        type: "address",
      },
    ],
    name: "Donate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "hashedinput",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_signer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_verifier",
        type: "address",
      },
    ],
    name: "RegisterCertificates",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "hashedinput",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_signer",
        type: "address",
      },
    ],
    name: "SignCertificate",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "Incentives",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_website",
        type: "string",
      },
      {
        internalType: "string",
        name: "_image",
        type: "string",
      },
    ],
    name: "addAuthority",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "announceIncentive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorities",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "website",
        type: "string",
      },
      {
        internalType: "string",
        name: "image",
        type: "string",
      },
      {
        internalType: "enum CertiDapp.List",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "certificates",
    outputs: [
      {
        internalType: "string",
        name: "hash",
        type: "string",
      },
      {
        internalType: "address",
        name: "Signer",
        type: "address",
      },
      {
        internalType: "address",
        name: "Verifier",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "Balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "input",
        type: "bytes32",
      },
    ],
    name: "collect",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "dayswappers",
    outputs: [
      {
        internalType: "contract IDayswappers",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "input",
        type: "bytes32",
      },
    ],
    name: "donate",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "input",
        type: "bytes32",
      },
    ],
    name: "getBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "kycDapp",
    outputs: [
      {
        internalType: "contract IKycDapp",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nrtManager",
    outputs: [
      {
        internalType: "contract INRTManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "prepaidEs",
    outputs: [
      {
        internalType: "contract IPrepaidEs",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "randomnessManager",
    outputs: [
      {
        internalType: "contract RandomnessManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_hash",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_Signer",
        type: "address",
      },
    ],
    name: "registerCertificates",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddressStrict",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsername",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsernameStrict",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_kycDapp",
        type: "address",
      },
    ],
    name: "setKycDapp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes",
      },
    ],
    name: "splitSignature",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyClub",
    outputs: [
      {
        internalType: "contract ITimeAllyClub",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyManager",
    outputs: [
      {
        internalType: "contract ITimeAllyManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyPromotionalBucket",
    outputs: [
      {
        internalType: "contract ITimeAllyPromotionalBucket",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "validatorManager",
    outputs: [
      {
        internalType: "contract IValidatorManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "verifyString",
    outputs: [
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";
